// extracted by mini-css-extract-plugin
export default {"BurgerLayout":"styles_BurgerLayout__GvZRv"};